import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
// import Typography from '@material-ui/core/Typography';
// import RemoveIcon from '@material-ui/icons/Remove';
// import CheckIcon from '@material-ui/icons/Check';

import './ValueSetDialogJson.css';

const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
    },
});


export default function ValueSetDialogJson(props) {
    const classes = useStyles();

    useEffect(() => {
        if (props) {
            // console.log('props', props);
        }
    });

    function showRawData() {
        // console.log("pp", props)
        return JSON.stringify(props, null, 2)
    }

    return (
        <Paper className={classes.root}>
            <div className="vsDialogData">
                <pre className="vsDialogData_json">
                    {showRawData()}
                </pre>
            </div>
        </Paper>
    );
}
